import axios from 'axios';
import { APICore } from './apiCore';

const api = new APICore();

interface RitualDetails {
    name: string;
    description?: string;
    category?: string;
    defaultPrice?: number;
    imageUrl?: string;
    serviceIds?: number[];
    productIds?: string[];
}

// Get rituals with pagination and filtering
function getRituals(params: {
    limit?: number;
    page?: number;
    search?: string;
    serviceId?: number;
    productId?: string;
    poojariId?: number;
}) {
    const baseUrl = '/rituals';
    return api.get(`${baseUrl}`, params);
}

// Get single ritual by ID
function getRitualById(params: { ritualId: string }) {
    const baseUrl = `/rituals/${params.ritualId}`;
    return api.get(`${baseUrl}`, '');
}

// Create new ritual
function addRitual(params: { ritualDetails: RitualDetails }) {
    const baseUrl = '/rituals';
    return api.create(`${baseUrl}`, params.ritualDetails);
}

// Update existing ritual
function updateRitual(params: {
    ritualId: string;
    ritualDetails: Partial<RitualDetails>;
}) {
    const baseUrl = `/rituals/${params.ritualId}`;
    return api.updatePatch(`${baseUrl}`, params.ritualDetails);
}

// Delete ritual
function deleteRitual(params: { ritualId: string }) {
    const baseUrl = `/rituals/${params.ritualId}`;
    return api.delete(`${baseUrl}`);
}

// Link services to ritual
function tagServiceToRituals(params: { ritualIds: number[]; serviceId: number }) {
    const baseUrl = '/rituals/service-rituals';
    return api.updatePatch(`${baseUrl}`, params);
}

// Link products to ritual
function tagProductToRituals(params: { ritualIds: number[]; productId: string }) {
    const baseUrl = '/rituals/product-rituals';
    return api.updatePatch(`${baseUrl}`, params);
}

// Get rituals by service
function getRitualsByService(params: { serviceId?: string; limit?: number; page?: number }) {
    const baseUrl = '/rituals/service-rituals';
    return api.get(`${baseUrl}`, params);
}

// Get rituals by product
function getRitualsByProduct(params: { productId?: string; limit?: number; page?: number }) {
    const baseUrl = '/rituals/product-rituals';
    return api.get(`${baseUrl}`, params);
}

// Assign ritual to poojari
function assignRitualToPoojari(params: {
    poojariId: number;
    ritualId: number;
    price: number;
    notes?: string;
    duration?: string;
}) {
    const baseUrl = '/rituals/poojari-rituals';
    return api.create(`${baseUrl}`, params);
}

// Get rituals by poojari
function getRitualsByPoojari(params: { poojariId: string; limit?: number; page?: number }) {
    const baseUrl = `/rituals/poojari/${params.poojariId}`;
    return api.get(`${baseUrl}`, { limit: params.limit, page: params.page });
}

// Get poojaris by ritual
function getPoojarisByRitual(params: { ritualId: string; limit?: number; page?: number }) {
    const baseUrl = `/rituals/poojaris/${params.ritualId}`;
    return api.get(`${baseUrl}`, { limit: params.limit, page: params.page });
}

// Update poojari-ritual assignment
function updatePoojariRitual(params: {
    poojariRitualId: string;
    price?: number;
    notes?: string;
    duration?: string;
}) {
    const baseUrl = `/rituals/poojari-ritual/${params.poojariRitualId}`;
    return api.updatePatch(`${baseUrl}`, {
        price: params.price,
        notes: params.notes,
        duration: params.duration
    });
}

// Remove ritual from poojari
function removeRitualFromPoojari(params: { poojariId: string; ritualId: string }) {
    const baseUrl = `/rituals/poojari/${params.poojariId}/ritual/${params.ritualId}`;
    return api.delete(`${baseUrl}`);
}

export {
    getRituals,
    getRitualById,
    addRitual,
    updateRitual,
    deleteRitual,
    tagServiceToRituals,
    tagProductToRituals,
    getRitualsByService,
    getRitualsByProduct,
    assignRitualToPoojari,
    getRitualsByPoojari,
    getPoojarisByRitual,
    updatePoojariRitual,
    removeRitualFromPoojari
};
